import React, { Component } from "react";
import left from "../../assets/icons/left.png";
import { Col, Row, Button } from "react-bootstrap";
import Dropdown from "../sub_components/dropdown/components/Dropdown";
import save from "../../assets/save.png";

class settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goBack: false,
      fps: [
        {
          id: 0,
          title: "15",
          selected: false,
          key: "15"
        },
        {
          id: 1,
          title: "20",
          selected: false,
          key: "20"
        },
        {
          id: 2,
          title: "30",
          selected: false,
          key: "30"
        },
        {
          id: 3,
          title: "60",
          selected: false,
          key: "60"
        }
      ]
    };
  }
  returnBack = () => {
    this.props.handleSettingsProps();
  };

  componentWillMount() {
    console.log('called');
    
  }
  
  resetThenSet = (id, key) => {
    /* let temp = JSON.parse(JSON.stringify(this.state[key]));
    temp.forEach(item => (item.selected = false));
    temp[id].selected = true;
    this.setState({
      [key]: temp
    }); */
  };
  render() {
    return (
      <div>
        <Row>
          <div style={{ marginTop: "21px" }}>
            <Col xs={1} style={{ marginLeft: "10px" }}>
              <img onClick={this.returnBack} src={left} />
            </Col>
            <Col xs={9} style={{ paddingLeft: "9px" }}>
              <div style={{ color: "#C2C0BD", paddingTop: "1px" }}>
                Settings
              </div>
            </Col>
          </div>
        </Row>
        <Row>
          <div
            style={{ marginLeft: "15px", marginTop: "33px", color: "#C2C0BD" }}
          >
            <Row>
              <div>
                <Col xs={6}>
                  <div style={{ marginLeft: "58px" }}>FPS</div>
                </Col>
                <Col xs={6} style={{ paddingLeft: "0px", paddingTop: '4px' }}>
                  <div>
                    <Dropdown
                      default={this.state.fps[0]["title"]}
                      list={this.state.fps}
                      resetThenSet={this.resetThenSet}
                      width={"50px"}
                      /* bStyle={'0.5px solid #475A82'}
                      bRadius={'6px'} */
                    />
                  </div>
                </Col>
              </div>
            </Row>
            <Row>
              <div style={{ marginTop: "25px" }}>
                <Col xs={6}>
                  <div style={{ marginLeft: "58px" }}>Hold To Record</div>
                </Col>
                <Col xs={6} style={{ paddingLeft: "0px", paddingTop: '4px' }}>
                  <div>
                    <Dropdown
                      default={this.state.fps[0]["title"]}
                      title="16"
                      list={this.state.fps}
                      resetThenSet={this.resetThenSet}
                      width={"50px"}
                    />
                  </div>
                </Col>
              </div>
            </Row>
            <Row>
              <div style={{ marginTop: "25px" }}>
                <Col xs={6}>
                  <div style={{ marginLeft: "58px" }}>Delay</div>
                </Col>
                <Col xs={6} style={{ paddingLeft: "0px", paddingTop: '4px' }}>
                  <div>
                    <Dropdown
                      default={this.state.fps[0]["title"]}
                      title="16"
                      list={this.state.fps}
                      resetThenSet={this.resetThenSet}
                      width={"50px"}
                    />
                  </div>
                </Col>
              </div>
            </Row>
            <Row>
              <div style={{ marginTop: "25px" }}>
                <Col xs={6}>
                  <div style={{ marginLeft: "58px" }}>Duration</div>
                </Col>
                <Col xs={6} style={{ paddingLeft: "0px", paddingTop: '4px' }}>
                  <div>
                    <Dropdown
                      default={this.state.fps[0]["title"]}
                      title="16"
                      list={this.state.fps}
                      resetThenSet={this.resetThenSet}
                      width={"50px"}
                    />
                  </div>
                </Col>
              </div>
            </Row>
            <Row>
              <div
                style={{
                  marginLeft: "73px",
                  marginBottom: "81px",
                  marginTop: "25px"
                }}
              >
                <Button
                  style={{
                    width: "68px",
                    height: "21px",
                    outline: "none",
                    margin: "0px",
                    color: "#C2C0BD",
                    padding: "1.5px 22px",
                    backgroundColor: "#2E3A53",
                    fontSize: "10px",
                    fontWeight: "300px",
                    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)"
                  }}
                >
                  {/* <img src={save}/> */}
                  Save
                </Button>
              </div>
            </Row>
          </div>
        </Row>
      </div>
    );
  }
}

export default settings;
